import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

import messages from 'utils/messages'
import Modal from 'components/Modal'
import { DEFAULT_ACCENT } from '../../utils/constants'
import { Select } from '../../containers/CustomDashboard/Dashboard/details/editor/inputs/Select'
import './style.scss'

const ModalCheckbox = ({ title, color = DEFAULT_ACCENT, confirmMessage, checkboxText, onClose, onConfirm, isLoading, onCheckboxChange, hideWarning, note, selectList, onUpdateOption, value, needConfirm = true, hideCheckBox, confirmColor = 'success', confirmText, confirmDisabled }) => {
  const [isAccepted, toggleAccepted] = useState(false)
  const [selectedValue, setSelectedValue] = useState(value)

  const onChange = () => {
    onCheckboxChange && onCheckboxChange(!isAccepted)
    toggleAccepted(!isAccepted)
  }

  const enableConfirm = () => {
    let isEnabled = false

    if (hideCheckBox) {
      if (selectList) {
        isEnabled = !!(selectedValue && selectedValue.value)
      } else {
        isEnabled = true
      }
    } else if (selectList) {
      isEnabled = !!(selectedValue && selectedValue.value) && isAccepted
    } else {
      isEnabled = isAccepted
    }

    return isEnabled || !needConfirm
  }

  const hasConfirm = typeof onConfirm === 'function'

  const buttons = [
    hasConfirm && (
      <button
        className={
          classNames(
            'modal__confirm',
            `viso-text-${enableConfirm() ? confirmColor : 'border'}`
          )
        }
        key='confirm'
        disabled={isLoading || !enableConfirm() || confirmDisabled}
        onClick={() => onConfirm(selectedValue)}
      >
        {isLoading ? (
          <FormattedMessage {...messages.loading} />
        ) : (
          confirmText || <FormattedMessage {...messages.confirm} />
        )}
      </button>
    ),
    <button
      className='modal__cancel'
      key='cancel'
      onClick={onClose}
    >
      <FormattedMessage {...messages.cancel} />
    </button>
  ].filter(Boolean)

  return (
    <Modal
      buttons={buttons}
      title={title}
      body={
        <div>
          <div>{confirmMessage} {!hideWarning && 'Are you sure you want to continue?'}</div>

          {selectList &&
            <div className='modal__select'>
              <Select
                selectedOption={selectedValue}
                options={selectList}
                onChange={(data) => {
                  if(onUpdateOption) {
                    onUpdateOption(data)
                  }
                  setSelectedValue(data)
                }}
                placeholder='Select...'
              />
            </div>
          }

          {note &&
            <div className='model-body-container'>
              <div className='grid-row mx-b-3'>
                <div className='grid-col'>{note.title && <span><strong>{note.title}</strong>: </span>}{note.text}</div>
              </div>
            </div>
          }

          {!hideCheckBox &&
            <div className='modal__checkbox'>
              <input
                type='checkbox'
                name='confirmCheckbox'
                className='checkbox__input modal__checkbox__input'
                onChange={onChange}
                checked={isAccepted}
              />
              <div className={`checkbox__check ${color}`} />
              <label
                className={
                  classNames(
                    'checkbox__label modal__checkbox__label',
                    `viso-text-${isAccepted ? 'text' : 'label'}`
                  )
                }
                onClick={onChange}
              >
                {checkboxText || <FormattedMessage {...messages.confirmAndProceed} />}
              </label>
            </div>
          }
        </div>
      }
      onClose={onClose}
    />
  )
}

export default ModalCheckbox